import React, { useContext } from "react";
import { NavLink, Link } from "react-router-dom";
import "./TaskCard.css";
import { Tooltip } from "@mui/material";

const TaskCard = ({
  title,
  description,
  data,
  type,
  deadline,
  progress,
  totalTests,
  link,
  confDate,
  confTime,
  target,
  course,
}) => {
  const getDeadlineColor = (deadline) => {
    switch (deadline) {
      case 4:
        return "#22C532";
      case 3:
      case 2:
        return "#F6C71E";
      case 1:
      case 0:
        return "#FF0000";

      default:
        return "";
    }
  };
  
  const handleType = (type) => {
    switch (type) {
      case 'test': 
      return 'Тест'
      case 'exercise':
      return 'Упражнение'
      default:
        return type
    }
  }

  // console.log(course);
  return (
    // <Tooltip title={course} placement="top-start" followCursor componentsProps={{
    //     tooltip: {
    //       sx: {
    //         bgcolor: '#ffffff',
    //         'box-shadow': '0px 4px 20px 0px #0000001F',
    //         color: '#464646',
    //         'font-size': '17px',
    //         'line-height': '28px',
    //         'border-radius': '7px',
    //         '& .MuiTooltip-arrow': {
    //           color: 'black',
    //         },
    //       },
    //     },
    //   }} >

    <Link to={link} target={`${target}`}>
      {" "}
      <div className="taskCard__container">
        <div className="taskCard__header">
          <div className="takCard__headerWrap">
            {course !== undefined && (
              <>
                <div className="taskCard__tooltip">{course}</div>
                <div
                  className={`${
                    data ? "taskCard__percentage" : "taskCard__type _course"
                  }`}
                >
                  Курс
                </div>
                <div className="taskCard__title _course">{course}</div>
              </>
            )}
          </div>
          <div
            className={`${data ? "taskCard__percentage" : "taskCard__type"}`}
          >
            {data ? data : handleType(type)}
          </div>
          {(deadline || progress || confDate || confTime) && (
            <div className="taskCard__tips">
              {deadline !== undefined && (
                <div
                  className="taskCard__deadline"
                  style={{ backgroundColor: getDeadlineColor(deadline) }}
                >{`${deadline} дн.`}</div>
              )}
              {progress && (
                <div className="taskCard__attempts">{`${progress}`}</div>
              )}
              {confTime && (
                <div className="taskCard__time">{`${confTime}`}</div>
              )}
              {confDate && (
                <div className="taskCard__date">{`${confDate}`}</div>
              )}
            </div>
          )}
        </div>
        <div className="taskCard__title">{title}</div>
        <div className="taskCard__description">
          {description ? description : ""}
        </div>
      </div>
    </Link>
    //  </Tooltip>
  );
};
export default TaskCard;
